export default {
    getCountriesSelect: function(state) {
        return state.countriesSelect;
    },
    getCountriesSelectPriceList: function(state) {
        return state.countriesSelectPriceList;
    },
    getNameSelect: function(state) {
        return state.namesSelect;
    },
    getClientId: function(state) {
        return state.clientId;
    },
    getPriceLists: function(state) {
        return state.priceLists;
    },
    getIdNumbersTypes: function(state) {
        return state.idNumberTypesSelect;
    },
    getCurrentSaDepartment: state => {
        return state.currentSaDepartment;
    },
    getSelectedSaDepartment: state => {
        return state.selectedSaDepartment;
    },
    getErrors: state => {
        return state.errors;
    },
    getOld: state => {
        return state.old;
    },
    getValues: state => {
        return state.values;
    }
};
